// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Warranties from '../state/warranties';
import WarrantyCoverageItem from '../../../product/details/components/warranty-coverage-panel/warranty-coverage-item';

const PartsCoverageSearchWarrantyDetails = props => {

    const warrantyCoverageItems = props.warranties.map(warrantyCoverageItem =>
        <WarrantyCoverageItem
            key={warrantyCoverageItem.id + warrantyCoverageItem.warrantyItemText.replace(/ /g, '_')}
            maintenancePlanLink={false}
            showDisabledClass={false}
            warranty={warrantyCoverageItem}
        />
    );

    return (
        <div className={'part-coverage-search-warranty-details'}>
            <h2>{props.pin}</h2>
            <section className='warranty-coverage-panel'>
                {warrantyCoverageItems}
            </section>
        </div>
    );

};

PartsCoverageSearchWarrantyDetails.displayName = 'PartsCoverageSearchWarrantyDetails';
PartsCoverageSearchWarrantyDetails.propTypes = {
    pin: PropTypes.string.isRequired,
    warranties: PropTypes.arrayOf(PropTypes.instanceOf(Warranties)).isRequired
};

export default PartsCoverageSearchWarrantyDetails;



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/components/parts-coverage-search-warranty-details.js